import React, { useState } from 'react';
import './auth.css';
import { API_BASE } from '../config/api';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/auth/reset-password/request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json().catch(() => ({}));
      
      if (!res.ok) {
        throw new Error(data.error || 'Failed to send reset email');
      }

      setSuccess(data.message || 'Password reset email sent! Please check your inbox and follow the instructions.');
      setEmail('');
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h1>Reset password</h1>
        <p className="subtle">Enter your email address and we'll send you instructions to reset your password.</p>
        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label>Email</label>
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              placeholder="your@email.com"
              required 
              disabled={loading}
            />
          </div>
          {error && (
            <div className="auth-error" role="alert">{error}</div>
          )}
          {success && (
            <div className="auth-success" role="status">{success}</div>
          )}
          <div className="auth-actions">
            <button className="button" type="submit" disabled={loading}>
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
            <a href="/auth/login">Back to login</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
